export enum EMyStatusCode {
  FAILED_RESPONSE = 0,
}
